/**
 * Search Drawer System
 *
 * Handles opening/closing of the header search drawer with transitions and focus.
 */

export const initSearch = () => {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const searchToggle = header.querySelector('.search-toggle');
  const searchDrawer = header.querySelector('.search-drawer');
  const searchClose = header.querySelector('.search-close-btn');
  const searchInput = header.querySelector('.search-input');

  if (!searchToggle || !searchDrawer || !searchClose || !searchInput) return;

  let lastFocusedElement = null;

  const openSearch = () => {
    lastFocusedElement = document.activeElement;
    header.classList.add('search-open');
    searchToggle.setAttribute('aria-expanded', 'true');
    searchDrawer.setAttribute('aria-hidden', 'false');
    // Small timeout to allow transition to begin and input to become visible
    setTimeout(() => {
      searchInput.focus();
    }, 100);
  };

  const closeSearch = () => {
    header.classList.remove('search-open');
    searchToggle.setAttribute('aria-expanded', 'false');
    searchDrawer.setAttribute('aria-hidden', 'true');
    searchInput.blur();
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  };

  searchToggle.addEventListener('click', (e) => {
    e.preventDefault();
    openSearch();
  });

  searchClose.addEventListener('click', (e) => {
    e.preventDefault();
    closeSearch();
  });

  // Close search drawer on Escape key press
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && header.classList.contains('search-open')) {
      closeSearch();
    }
  });
};
